module.exports = __webpack_public_path__ + "static/media/c5bannerModul4_small.c2795d75.jpg";